import { render, staticRenderFns } from "./BlackoutContents.vue?vue&type=template&id=f065bbb0"
import script from "./BlackoutContents.vue?vue&type=script&lang=js"
export * from "./BlackoutContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports